import { ENV_TYPE } from '../../../lib/constants'
import * as pxp from '../lib/pxp'
import { getFlowType } from '../transfer/utils/url-utils'

/*
 * Ease of Payments Features
 *  - Cross Border (XB | Mental Model)
 *  - Money Movement (Flow Consolidation)
 *  - Payhub Entry Points (XB)
 */

// STAGE: https://internal.msmaster.qa.paypal.com/elmo/experiment/138388
// PROD:  https://admin.paypalinc.com/elmo/experiment/110827
const omittedFlows = [ENV_TYPE.DONATE, ENV_TYPE.PISP, ENV_TYPE.INTERNATIONAL, ENV_TYPE.PROFILE, ENV_TYPE.GROUPS]
const isOmittedFlow = env => omittedFlows.includes(env)

export function isCrossBorderTrmt() {
  // Removing checking Trmt_p2p_crossborder_flow
  return true
}

// STAGE: https://internal.msmaster.qa.paypal.com/elmo/experiment/138385
// Not supported at the moment for pay requests
export function isMoneyMovementTrmt() {
  const store = require('../transfer/stores/configureStore')
  const env = store.default.getState().server.env
  if (isOmittedFlow(env)) {
    return false
  }
  const isPayRequest = getFlowType() === ENV_TYPE.PAY_REQUEST
  return pxp.isTreatment('Trmt_p2p_money_movement_flow') && !isPayRequest
}

export function isPayhubEntryPoints() {
  return pxp.isTreatment('Trmt_p2p_payhub_entry_points')
}
